import { select, call, put } from "redux-saga/effects";
import { validateShopper as validateShopperPromise } from "@bitComponents/adabyron/register";
import { WEB_SERVICES } from "./webServices";

const contextStore = (state) => state.context.data;

export function* validateShopper(params) {
  const { reduxUpdate, pin, normalizeHttpErrors } = params;
  try {
    const context = yield select(contextStore);
    const { successUpdate } = reduxUpdate;
    const args = {
      pin,
    };
    const response = yield call(validateShopperPromise, args, context);
    if (successUpdate) {
      yield put(successUpdate(response));
    }
    return response;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(
      normalizeHttpErrors,
      WEB_SERVICES.VALIDATE_SHOPPER,
      error
    );
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
